import React from 'react';
import Checkbox from '@mui/material/Checkbox';

export const CustomCheckbox = ({ route, selectedRouteIds, handleCheckboxChange }) => {
  const isChecked = selectedRouteIds.includes(route.id);

  const checkedIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#FF6066" fillOpacity="0.12" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#BD1D23" />
      <path
        d="M7.375 9.875L12.25 5L13 5.75L7.375 11.375L4 8.00001L4.75 7.25002L7.375 9.875Z"
        fill="#BD1D23"
      />
    </svg>
  );

  const uncheckedIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#46ebeb" fillOpacity="0.12" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#46ebeb" />
      <path
        d="M7.375 9.875L12.25 5L13 5.75L7.375 11.375L4 8.00001L4.75 7.25002L7.375 9.875Z"
        fill="#46ebeb"
      />
    </svg>
  );

  return (
    <Checkbox
      icon={uncheckedIcon}
      checkedIcon={checkedIcon}
      checked={isChecked}
      onChange={() => handleCheckboxChange(route.id)}
    />
  );
};
